import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { ORDER_ADS_DRAFT } from 'constants/ui/storageKey';
import { OrderAdsCampaignForm } from 'api';

export type FormState<T> = {
  currentStep: number;
  totalStep: number;
  formData: T;
  setFormData: (data: T) => void;
  clearFormData: () => void;
  nextStep: () => void;
  goToStep: (step: number) => void;
  getCurrentStep: () => number;
  getState: () => FormState<T>;
  discardFlow: () => void;
};

export const useCreateAdsCampaignOrderStore = <T>() =>
  create(
    persist<FormState<T>>(
      (set, get) => ({
        currentStep: 1,
        totalStep: 5,
        formData: {} as T,
        setFormData: (data: T) => {
          set(state => {
            const newFormData = {
              ...state.formData,
              ...data,
            };
            return {
              ...state,
              formData: newFormData,
            };
          });
        },
        clearFormData: () => {
          set({
            currentStep: 1,
            formData: {} as T,
          });
          sessionStorage.removeItem(ORDER_ADS_DRAFT);
        },
        nextStep: () => {
          set(state => ({
            ...state,
            currentStep: state.currentStep + 1,
          }));
        },
        goToStep: (step: number) => {
          set(state => ({
            ...state,
            currentStep: step,
          }));
        },
        getCurrentStep: () => get().currentStep,
        getState: () => get(),
        discardFlow: () => {
          set(state => ({
            ...state,
            currentStep: 1,
            formData: {} as T,
          }));
          sessionStorage.removeItem(ORDER_ADS_DRAFT);
        },
      }),
      {
        name: ORDER_ADS_DRAFT,
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  );

export const createAdsCampaignOrderStore = useCreateAdsCampaignOrderStore<OrderAdsCampaignForm>();
